(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (this.lifecycleController) return;
      this.lifecycleController = new AbortController();
      const { signal } = this.lifecycleController;
      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerMeasureFrame = null;
      this.scrollFrame = null;
      this.currentScrollTop = this.getScrollTop();
      this.processedScrollTop = this.currentScrollTop;
      this.downwardTravel = 0;
      this.upwardTravel = 0;
      this.headerHasFocus = false;
      this.stickyState = 'visible';
      this.predictiveSearch = this.querySelector('predictive-search');
      this.header.dataset.scoreggiaStickyState = 'visible';

      this.setHeaderHeight();
      this.headerMediaQuery = window.matchMedia('(max-width: 990px)');
      this.onViewportChange = () => {
        this.scheduleHeaderMeasurement(true);
        this.scheduleScrollState();
      };
      this.onSectionChange = () => {
        this.scheduleHeaderMeasurement(true);
        this.scheduleScrollState();
      };
      this.headerMediaQuery.addEventListener('change', this.onViewportChange);
      window.addEventListener('resize', this.onViewportChange, { passive: true, signal });
      window.addEventListener('orientationchange', this.onViewportChange, { passive: true, signal });
      window.visualViewport?.addEventListener('resize', this.onViewportChange, { passive: true, signal });
      document.addEventListener('shopify:section:load', this.onSectionChange, { signal });
      document.addEventListener('shopify:section:unload', this.onSectionChange, { signal });
      document.addEventListener('product-info:loaded', this.onViewportChange, { signal });
      document.addEventListener('product-info:variant-rendered', this.onViewportChange, { signal });
      document.addEventListener('media-gallery:ready', this.onViewportChange, { signal });

      if ('ResizeObserver' in window) {
        this.headerResizeObserver = new ResizeObserver(() => this.scheduleHeaderMeasurement());
        this.observeLayoutTargets();
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.onScrollHandler = this.onScroll.bind(this);
      this.preventHeaderReveal = () => {
        this.upwardTravel = 0;
        if (this.getScrollTop() > 2) this.hide('hidden');
      };
      this.handleFocusIn = (event) => this.onFocusIn(event);
      this.handleFocusOut = (event) => this.onFocusOut(event);
      this.handleTransitionEnd = (event) => this.onTransitionEnd(event);

      this.addEventListener('preventHeaderReveal', this.preventHeaderReveal, { signal });
      window.addEventListener('scroll', this.onScrollHandler, { passive: true, signal });
      document.addEventListener('focusin', this.handleFocusIn, { signal });
      document.addEventListener('focusout', this.handleFocusOut, { signal });
      this.header.addEventListener('transitionend', this.handleTransitionEnd, { signal });
      document.fonts?.ready?.then(() => {
        if (!signal.aborted) this.scheduleHeaderMeasurement(true);
      });

      this.setStickyState('visible', { animate: false, atPageTop: this.currentScrollTop <= 2 });
      this.scheduleScrollState();
    }

    setHeaderHeight() {
      if (!this.header?.isConnected) return;
      const headerHeight = Math.ceil(this.header.getBoundingClientRect().height || this.header.offsetHeight || 0);
      const additionalStickyHeight = Array.from(document.querySelectorAll('.shopify-section-group-header-group'))
        .filter((section) => section !== this.header)
        .reduce((height, section) => {
          const style = window.getComputedStyle(section);
          if (!['fixed', 'sticky'].includes(style.position)) return height;
          const rect = section.getBoundingClientRect();
          return height + Math.max(0, Math.ceil(rect.height));
        }, 0);
      this.measuredHeaderClearance = headerHeight + additionalStickyHeight;
      this.upwardRevealThreshold = Math.min(48, Math.max(24, this.measuredHeaderClearance * 0.3));
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty(
        '--scoreggia-header-clearance',
        `calc(${this.measuredHeaderClearance}px + env(safe-area-inset-top, 0px))`,
      );
    }

    scheduleHeaderMeasurement(refreshObservers = false) {
      if (this.headerMeasureFrame !== null) return;
      this.headerMeasureFrame = requestAnimationFrame(() => {
        this.headerMeasureFrame = null;
        if (!this.isConnected) return;
        if (refreshObservers) this.observeLayoutTargets();
        this.setHeaderHeight();
        this.scheduleScrollState();
      });
    }

    observeLayoutTargets() {
      if (!this.headerResizeObserver) return;
      this.headerResizeObserver.disconnect();
      document
        .querySelectorAll('.shopify-section-group-header-group')
        .forEach((section) => this.headerResizeObserver.observe(section));
    }

    disconnectedCallback() {
      this.lifecycleController?.abort();
      this.lifecycleController = null;
      this.headerMediaQuery?.removeEventListener('change', this.onViewportChange);
      this.headerResizeObserver?.disconnect();
      this.headerResizeObserver = null;
      if (this.headerMeasureFrame !== null) cancelAnimationFrame(this.headerMeasureFrame);
      if (this.scrollFrame !== null) cancelAnimationFrame(this.scrollFrame);
      this.headerMeasureFrame = null;
      this.scrollFrame = null;
    }

    scheduleScrollState() {
      if (this.scrollFrame !== null) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (this.isConnected) this.processScrollState();
      });
    }

    onScroll() {
      this.currentScrollTop = this.getScrollTop();
      this.scheduleScrollState();
    }

    processScrollState() {
      const scrollTop = this.getScrollTop();
      const delta = scrollTop - this.processedScrollTop;
      this.currentScrollTop = scrollTop;
      this.processedScrollTop = scrollTop;

      if (scrollTop <= 2) {
        this.downwardTravel = 0;
        this.upwardTravel = 0;
        this.reset();
        return;
      }

      this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
      if (this.headerHasFocus) {
        this.reveal('revealed-for-header-focus');
        return;
      }

      if (this.predictiveSearch?.isOpen || this.header.classList.contains('menu-open')) {
        this.reveal('visible');
        return;
      }

      if (this.headerIsAlwaysSticky) {
        this.reveal('visible');
        return;
      }

      if (delta > 0) {
        this.upwardTravel = 0;
        this.downwardTravel += delta;
        if (this.downwardTravel >= 8 && !this.preventHide) this.hide('hidden');
        return;
      }

      if (delta < 0) {
        this.downwardTravel = 0;
        this.upwardTravel += Math.abs(delta);
        if (this.upwardTravel >= this.upwardRevealThreshold) {
          this.reveal('visible');
        }
      }
    }

    hide(state = 'hidden') {
      this.setStickyState(state, { animate: true, atPageTop: false });
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal(state = 'visible') {
      this.setStickyState(state, { animate: true, atPageTop: false });
    }

    reset() {
      this.setStickyState('visible', { animate: false, atPageTop: true });
    }

    setStickyState(state, { animate = true, atPageTop = false } = {}) {
      const hidden = state === 'hidden';
      const wasHidden = this.stickyState === 'hidden';
      const stateChanged = this.stickyState !== state;
      this.stickyState = state;
      this.header.dataset.scoreggiaStickyState = state;
      this.header.classList.toggle('shopify-section-header-hidden', hidden);
      this.header.classList.toggle('animate', animate);
      if (atPageTop && !hidden && !this.headerIsAlwaysSticky) {
        this.header.classList.remove('shopify-section-header-sticky', 'scrolled-past-header');
      } else {
        this.header.classList.add('shopify-section-header-sticky');
      }
      if (!hidden) {
        delete this.header.dataset.scoreggiaStickyFullyHidden;
      } else if (wasHidden || !animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.header.dataset.scoreggiaStickyFullyHidden = 'true';
      } else {
        delete this.header.dataset.scoreggiaStickyFullyHidden;
      }
      if (stateChanged && !hidden) this.upwardTravel = 0;
    }

    onTransitionEnd(event) {
      if (event.target !== this.header || event.propertyName !== 'transform') return;
      if (this.stickyState === 'hidden') {
        this.header.dataset.scoreggiaStickyFullyHidden = 'true';
      }
    }

    onFocusIn(event) {
      if (this.header.contains(event.target)) {
        this.headerHasFocus = true;
        this.reveal('revealed-for-header-focus');
      }
    }

    onFocusOut(event) {
      const nextTarget = event.relatedTarget;
      if (this.header.contains(event.target) && !this.header.contains(nextTarget)) {
        this.headerHasFocus = false;
      }
      this.scheduleScrollState();
    }

    getScrollTop() {
      return Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
